<template>
  <div class="document">
    <document-header :account="celebration.name" description="Comprovante<br>de Estorno"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Cliente</h4></div>
            <div class="item-box-content">
              <h5>CPF/CNPJ</h5>
              {{ customer.document | documentMasked }}
              <h5>Nome</h5>
              {{ customer.name }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Experiência</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ celebration.document | documentMasked }}
                </div>
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ celebration.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ celebration.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes do Estorno</h3></div>
        <div class="item-box-content">
          <div>
            <div class="row my-3" v-for="item in items" :key="item.heppiReference">
              <div class="col">
                Item: {{ item.item }}
                <br />
                Fatura: {{ item.heppiReference }}
                <br />
                Total: {{ item.amount | price }}
              </div>
              <div class="col">
                Cartão: {{ item.paymentMethod }}
                <br />
                Parcelas: {{ item.installments }}x de {{ (item.amountPaid / item.installments) | price }}
                <br />
                Status: {{ item.status }}
              </div>
            </div>
          </div>
          <hr class="my-3" />
          <div class="row">
            <div class="col-auto pa-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col pa-5">
              <h5>Motivo</h5>
              {{ description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import documentHeader from '@/components/documentHeader'

export default {
  name: 'chargeback',
  components: {
    documentHeader
  },
  data () {
    return {
      customer: {
        name: 'Gisela Gomes',
        document: '71527365450'
      },
      celebration: {
        name: 'PG Mentoria 2026',
        heppiAccount: '13657276-1',
        document: '61373220000155'
      },
      items: [
        {
          item: 'PG Standard 25',
          paymentMethod: 'MASTERCARD terminado em 4807',
          installments: 1,
          amount: 180.00,
          amountPaid: 194.02,
          heppiReference: '69d2738d9f2c65621f0ad8df',
          gatewayId: '28BA2D6F-1524-4D76-8F3D-A62E0444ABE0',
          status: 'Estornado'
        }
      ],
      date: '2026-04-24',
      description: 'Fez um pagamento duplicado no cartão'
    }
  },
  created () {
    document.title = 'Comprovante de Estorno - ' + this.celebration.name + ' - ' + this.customer.name + ' - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
